import { SearchPropertyStatus, searchPropertyStatusValues } from '../types';

export const isSearchPropertyStatus = (value: string): value is SearchPropertyStatus =>
  searchPropertyStatusValues.includes(value as SearchPropertyStatus);
